<template>
  <SalesReportWidgetHighlight
    :title="$gettext('SaaS')"
    :total="saasPaymentsTotal && saasPaymentsTotal.total_amount | currency(currencyCodes.EUR)"
    :vat="$gettext('VAT incl.')"
    :variant="`purple`"
    v-if="saasPaymentsTotal"
  />
</template>

<script>
import SalesReportWidgetHighlight from "./SalesReportWidgetHighlight.vue"
import { mapGetters, mapActions } from "vuex"
import { currencyCodes } from "@/constants"

export default {
  name: "SaasPaymentsWidget",
  
  components: { SalesReportWidgetHighlight },
  
  data() {
    return {
      isLoading: false
    }
  },
  
  computed: {
    ...mapGetters('salesReport', ['saasPaymentsTotal']),
    
    currencyCodes() {
      return currencyCodes
    }
  },
  
  async mounted() {
    // Load data when component mounts
    await this.loadData()
  },
  
  methods: {
    ...mapActions('salesReport', ['fetchSaasPaymentsTotal']),
    
    async loadData() {
      this.isLoading = true
      try {
        await this.fetchSaasPaymentsTotal()
      } catch (error) {
        console.error('Error loading SaaS payments total:', error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>